export function isShopInRenovation(shopManagerData)
{
    if (shopManagerData && shopManagerData.RenovationFrom && shopManagerData.RenovationFrom !== "" && shopManagerData.RenovationTo && shopManagerData.RenovationTo !== "") {
        const renovationFrom = new Date(shopManagerData.RenovationFrom);
        const renovationTo = new Date(shopManagerData.RenovationTo);
        const currentDate = new Date();
        return renovationFrom < currentDate && renovationTo > currentDate;
    }
    return false;
}

export function isShopClosed(shopManagerData)
{
    if (shopManagerData && shopManagerData.CloseDate && shopManagerData.CloseDate !== "") {
        const closeDate = new Date(shopManagerData.CloseDate);
        const currentDate = new Date();
        return closeDate < currentDate;
    }
    return false;
}


export function isShopOpen(shopManagerData)
{
    return !isShopInRenovation(shopManagerData) && !isShopClosed(shopManagerData)
}

export function filterShops(shops,options)
{
    let filteredShops = shops;
    if(options)
    {
       filteredShops = filteredShops.filter(shop => {
            const renovation = isShopInRenovation(shop.shopManagerData);
            const closed = isShopClosed(shop.shopManagerData);
            const open = isShopOpen(shop.shopManagerData);
            if(options.showInRenovation && renovation) return true;
            if(options.showClosed && closed) return true;
            if(options.showOpen && open) return true;
            return false;
       });
       
    }
    return filteredShops;
}